import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import BannerNotesMobile from './BannerNotesMobile';
import { useSelector, shallowEqual } from 'react-redux';
import { API_MATERIAL } from '../store/constants';
import Carousel from 'react-bootstrap/Carousel';
import ReactHtmlParser from 'react-html-parser';

const BannerHomeEducacion = (props) => {
  const user = useSelector((state) => state.user.authState, shallowEqual);
  const notes = useSelector((state) => state.notes.notes, shallowEqual);

  // ARRAY DE NOTAS PARA USUARIOS LOGUEADOS
  const loggedInNotes = useSelector(
    (state) => state.notes.bannerHomeLoggedIn,
    shallowEqual
  );

  // ARRAY DE NOTAS PARA NO LOGUEADOS
  const disloggedNotes = useSelector(
    (state) => state.notes.bannerHomeDislogged,
    shallowEqual
  );

  //Función para extraer el blockquote de las notas dentro de los textos

  const extraerBlockquote = (string) => {
    let indexStart = 0;
    let indexEnd = 200;

    for (let i = 0; i < string.length; i++) {
      if (string[i] == '<') {
        if (string[i + 1] == 'b') {
          if (string[i + 2] == 'l') {
            if (string[i + 3] == 'o') {
              indexStart = i;
            }
          }
        }
      }
      if (string[i] == '<') {
        if (string[i + 1] == '/') {
          if (string[i + 2] == 'b') {
            if (string[i + 3] == 'l') {
              if (string[i + 4] == 'o') {
                indexEnd = i + 13;
              }
            }
          }
        }
      }
    }

    return string.slice(indexStart, indexEnd);
  };

  // CONFIG MODAL
  const [index, setIndex] = useState(0);

  const handleSelect = (selectedIndex, e) => {
    setIndex(selectedIndex);
  };

  return (
    <section id="home-articulos">
      {notes.length > 0 && (
        <div className="container">
          {user == true ? (
            // RENDER DE BANNER CON NOTAS PARA USUARIOS LOGUEADOS
            <Carousel
              touch={true}
              nextLabel="Next"
              keyboard={true}
              activeIndex={index}
              onSelect={handleSelect}>
              {loggedInNotes.map((note) => (
                <Carousel.Item key={note['id_note']}>
                  <div className="container-note">
                    <div className="container-img-button">
                      <Link to="/entrenamiento-medico">
                        <button className="educacion-mas">
                          + ENTRENAMIENTO
                        </button>
                      </Link>
                      <Link
                        className="banner-note-img"
                        to={
                          user
                            ? '/entrenamiento-medico/rescate-y-mantenimiento'
                            : '/educacion'
                        }>
                        <img src="img/seccion-educacion.png"></img>
                      </Link>
                    </div>
                    <div className="note">
                      <p className="miga-de-pan rute texto-verde">
                        <Link
                          style={{ textDecoration: 'none', color: '#35aea9' }}
                          to="/entrenamiento-medico">
                          ENTRENAMIENTO MÉDICO{' '}
                        </Link>
                        /{' '}
                        <Link
                          style={{ textDecoration: 'none', color: '#35aea9' }}
                          to={`/entrenamiento-medico/${note.section['slug']}`}>
                          {note.section.name.toUpperCase()}{' '}
                        </Link>
                      </p>

                      <div className="row">
                        <div className="col-md-8">
                          <Link
                            style={{
                              textDecoration: 'none',
                              color: '#10144b',
                            }}
                            to={`/entrenamiento/${note['slug']}`}>
                            <h2 className="banner-home-educacion-title mb-5">
                              {note.name}
                            </h2>
                          </Link>
                        </div>
                        <div className="col-md-7">
                          <p className="parrafo">
                            {ReactHtmlParser(note.copete)}
                          </p>
                        </div>
                        <div
                          style={{
                            textAlign: 'justify',
                            color: '#840729 !important',
                          }}
                          className="col-md-5">
                          <div className="frase texto-bordo">
                            {ReactHtmlParser(extraerBlockquote(note.detail))}
                          </div>
                        </div>
                      </div>
                      <div className="row reverse-mobile">
                        <div className="col-md-7 autor">
                          {' '}
                          <span></span>
                          <div className="texto-verde">
                            <strong>{note.author && note.author.name}</strong>
                            <br></br>
                            {ReactHtmlParser(note.author && note.author.detail)}
                          </div>
                        </div>
                        <div className="col-md-5">
                          {' '}
                          <img
                            src="img/frase-linea.svg"
                            className="w-100"></img>{' '}
                          {note.author && (
                            <img
                              id="profile-image"
                              src={`${API_MATERIAL}/notes_authors/big/${note.author['file']}`}
                              className="ml-4"></img>
                          )}{' '}
                        </div>
                      </div>
                    </div>
                  </div>
                </Carousel.Item>
              ))}
            </Carousel>
          ) : (
              // RENDER DE NOTAS PARA NO LOGUEADOS
              <Carousel
                touch={true}
                nextLabel="Next"
                keyboard={true}
                activeIndex={index}
                onSelect={handleSelect}>
                {disloggedNotes.map((note) => (
                  <Carousel.Item key={note['id_note']}>
                    <div className="container-note">
                      <div className="container-img-button">
                        <Link to="/educacion">
                          <button className="educacion-mas">+ EDUCACION</button>
                        </Link>
                        <Link
                          className="banner-note-img"
                          to={
                            user
                              ? '/entrenamiento-medico/rescate-y-mantenimiento'
                              : '/educacion'
                          }>
                          <img src="img/seccion-educacion.png"></img>
                        </Link>
                      </div>
                      <div className="note">
                        <p className="miga-de-pan rute texto-verde">
                          <Link
                            style={{ textDecoration: 'none', color: '#35aea9' }}
                            to="/educacion">
                            EDUCACIÓN{' '}
                          </Link>
                        /{' '}
                          <Link
                            style={{ textDecoration: 'none', color: '#35aea9' }}
                            to={`/educacion/${note.section['slug']}`}>
                            {note.section.name.toUpperCase()}{' '}
                          </Link>
                        </p>

                        <div className="row">
                          <div className="col-md-8">
                            <Link
                              style={{
                                textDecoration: 'none',
                                color: '#10144b',
                              }}
                              to={`/nota/${note['slug']}`}>
                              <h2 className="banner-home-educacion-title mb-5">
                                {note.name}
                              </h2>
                            </Link>
                          </div>
                          <div className="col-md-7">
                            <p className="parrafo">
                              {ReactHtmlParser(note.copete)}
                            </p>
                          </div>
                          <div className="col-md-5">
                            <div className="frase texto-bordo">
                              {ReactHtmlParser(extraerBlockquote(note.detail))}
                            </div>
                          </div>
                        </div>
                        <div className="row reverse-mobile">
                          <div className="col-md-7 autor">
                            {' '}
                            <span></span>
                            <div className="texto-verde">
                              <strong>{note.author && note.author.name}</strong>
                              <br></br>
                              {ReactHtmlParser(note.author && note.author.detail)}
                            </div>
                          </div>
                          <div className="col-md-5">
                            {' '}
                            <img
                              src="img/frase-linea.svg"
                              className="w-100"></img>{' '}
                            {note.author && (
                              <img
                                id="profile-image"
                                src={`${API_MATERIAL}/notes_authors/big/${note.author['file']}`}
                                className="ml-4"></img>
                            )}{' '}
                          </div>
                        </div>
                      </div>
                    </div>
                  </Carousel.Item>
                ))}
              </Carousel>
            )}
        </div>
      )}
      {notes.length > 0 && (
        <div className="mobile-educacion-banner">
          <BannerNotesMobile
            user={user}
            extraerBlockquote={extraerBlockquote}
            educacionNotes={disloggedNotes}
            entrenamientoNotes={loggedInNotes}
          />
        </div>
      )}
    </section>
  );
};

export default BannerHomeEducacion;
